/* eslint-disable prettier/prettier */
import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    purchaseOrders: {},
    purchaseOrder: {},
    isLoadingTable: false,
    showReceiveModal: false,
    showHistoryLog: false,
    historyLog: ""
}

const mutations = {
    getPaginatedPosToReceive(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/purchaseorders/po-to-receive/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            response.data.data.forEach(d => {
                d.receivedDate = moment(d.receivedDate).format('MM/DD/YYYY')
                d.poDate = moment(d.poDate).format('MM/DD/YYYY')
                d.dateCreated = moment(d.dateCreated).format('MM/DD/YYYY HH:mm')
                d.initialCost = numeral(d.initialCost).format('0,0.00')
                d.totalAmount = numeral(d.totalAmount).format('0,0.00')
            })
            state.purchaseOrders = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openReceiveInfoModal(state, payload) {
        state.showReceiveModal = payload.showReceiveModal
        if (payload.purchaseOrder) {
            state.showReceiveModal = payload.showReceiveModal
            state.purchaseOrder = payload.purchaseOrder
        } else {
            state.purchaseOrder = {}
        }
    },
    openHistoryLogModal(state, payload) {
        state.showHistoryLog = payload.showHistoryLog
        if (payload.showHistoryLog) {
            state.historyLog = payload.historyLog
        } else {
            state.historyLog = ""
        }
    }
}

const actions = {
    getPaginatedPosToReceive({
        commit
    }, payload) {
        commit('getPaginatedPosToReceive', payload)
    },
    openReceiveInfoModal({
        commit
    }, payload) {
        commit('openReceiveInfoModal', payload)
    },
    openHistoryLogModal({
        commit
    }, payload) {
        commit('openHistoryLogModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}